import { useCompetitionCategories } from "../../redux/features/categories/selectors";
import { CompetitionCategory } from "../../redux/features/categories/slice";

const AllCompetitions = () => {
  const categories = useCompetitionCategories({
    excludeCategories: ["subscriberCompetitions"],
  });
  const onCompetitionClick = (category: CompetitionCategory) => {
    if (location.pathname !== "/") {
      location.href = `/?navigateTo=${category.type}`;
      return;
    }
    const scrollToCategoryEvent = new CustomEvent("scroll-to-category", {
      detail: category.type,
    });
    window.dispatchEvent(scrollToCategoryEvent);
  };
  return (
    <div className="w-full min-w-0">
      <div className="text-gray-1 font-jost text-xs lg:text-sm font-medium leading-4 lg:leading-5 uppercase">
        All competitions
      </div>
      <div className="grid grid-cols-2 gap-3 lg:gap-5 mt-3 lg:mt-4">
        {categories.map(category => (
          <button
            type="button"
            key={category.type}
            onClick={() => onCompetitionClick(category)}
            className="relative flex overflow-hidden items-center justify-between w-full min-h-[72px] pt-2 pr-6 pb-3 pl-4 lg:pt-[17px] lg:pr-6 lg:pb-[17px] lg:pl-3 gap-2 rounded-lg bg-white shadow-[0px_4px_11px_0px_rgba(0,0,0,0.08)] lg:shadow-[0px_8px_11px_0px_rgba(0,0,0,0.06)] cursor-pointer text-left">
            <div className="absolute left-0 -top-2 w-[49px] h-[57px] bg-[#6029CB] z-0 blur-[50px]" />
            <div className="absolute -bottom-[3px] -right-10 lg:-bottom-[15px] lg:-right-[82px] w-[49px] lg:w-[120px] h-[57px] lg:h-[49px] bg-[#CB2929] z-0 blur-[50px] lg:blur-[82px]" />
            <div className="relative z-10 flex max-lg:flex-col lg:flex-row lg:items-center gap-0 lg:gap-3 min-w-0">
              <div className="size-8 max-lg:mb-2.5 lg:size-10 shrink-0">
                {category.imageUrl ? (
                  <img src={category.imageUrl} alt="" width={40} height={40} className="h-8 lg:h-10 w-auto" />
                ) : null}
              </div>
              <div className="min-w-0">
                <div className="mb-1 text-sm lg:text-base text-dark-1 font-jost font-medium leading-5 lg:leading-5.5 break-words">
                  {category.title}
                </div>
                <div className="text-xs lg:text-sm text-gray-1 font-jost font-medium leading-4 lg:leading-5">
                  <span>{category.competitions.length}</span>{" "}
                  {category.competitions.length === 1 ? "Competition" : "Competitions"}
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 right-0 z-10 flex items-center justify-center size-8 bg-[#a3beff] rounded-tl-2xl">
              <img
                src="/assets/images/menu/all-competitions/chevron-right.svg"
                alt=""
                width={24}
                height={24}
                className="size-6"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AllCompetitions;
